import { Grid } from "@mantine/core";
import { useDocumentTitle } from "@mantine/hooks";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { device } from "../../lib/constants";
import { Overview } from "./Overview";
import { SummarySidePanel } from "./index";

export const DashboardView = (): JSX.Element => {
	const { t } = useTranslation();

	useDocumentTitle(`DAP: ${t("navigation.dashboard")}`);

	const sideViews = <SummarySidePanel />;

	return (
		<Wrapper>
			<Grid gutter={64}>
				<LeftColumn md={12} lg={8}>
					{/* <CurrenyManagementSetupAlert /> */}
					<Title className="text-textColor">Dashboard</Title>
					<ContentView>
						<Overview />
					</ContentView>
				</LeftColumn>
				<RightSideBar md={12} lg={4}>
					<SideView>{sideViews}</SideView>
				</RightSideBar>
			</Grid>
		</Wrapper>
	);
};

const RightSideBar = styled(Grid.Col)`
  @media ${device.tablet} {
    padding: 0 16px;
    margin-top: 24px;
  }
`;

const LeftColumn = styled(Grid.Col)`
  @media ${device.tablet} {
    padding: 0 16px;
  }
`;

const Wrapper = styled.div`
  margin: 0 36px;
  padding-top: 40px;
  padding-bottom: 40px;
`;

const ContentView = styled.div`
  margin-top: 24px;
`;

const Title = styled.h1`
  font-size: 36px;
  font-family: 'ProximaNovaBold', sans-serif;
  line-height: 49px;
  margin: 0;
`;

const SideView = styled.div``;
